import { Flex } from '@mantine/core'
import { Input } from '@gate/gui'
import { ChangeEvent, useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { replaceValue, stopEvent } from '@/utils/tools'
import { FundingFilterType } from '../index'
import { useTranslation } from 'next-i18next'
import useRateChange from '@/hooks/useRateChange'
import {
  FundingFilterRoundsStyled,
  FundingFilterRoundsItemStyled,
  FundingFilterRoundsBoxStyled,
  FundingFilterCustomFlexStyled,
} from '../style'

const FFAmount: React.FC<FundingFilterType> = ({ itemValue, handleChangeValue }) => {
  const { t } = useTranslation('fundraising')
  const { faitRateItem } = useRateChange()

  const [minValue, setMinValue] = useState('')
  const [maxValue, setMaxValue] = useState('')
  const [selectedValue, setSelectedValue] = useState('')

  // 处理金额回显
  useEffect(() => {
    if (itemValue) {
      // 检查是否匹配预设选项
      const isPresetValue = listData.some(item => item.value === itemValue)
      if (isPresetValue) {
        setSelectedValue(itemValue)
        setMinValue('')
        setMaxValue('')
      } else {
        setSelectedValue('')
        const [min, max] = itemValue.split('&')
        setMinValue(min)
        setMaxValue(max)
      }
    } else {
      setSelectedValue('')
      setMinValue('')
      setMaxValue('')
    }
  }, [itemValue])

  const handleInputChange = (_value: string, isMin: boolean) => {
    const value = replaceValue(_value)
    // 清除选择项
    setSelectedValue(' ')

    if (isMin) {
      setMinValue(value)
      handleChangeValue(`${value}${maxValue ? '&' + maxValue : ''}`)
    } else {
      setMaxValue(value)
      handleChangeValue(`${minValue}${value ? '&' + value : ''}`)
    }
  }

  const listData = [
    {
      value: '&1',
      label: `<${faitRateItem?.symbol}1M`,
    },
    {
      value: '1&5',
      label: `${faitRateItem?.symbol}1M-${faitRateItem?.symbol}5M`,
    },
    {
      value: '5&10',
      label: `${faitRateItem?.symbol}5M-${faitRateItem?.symbol}10M`,
    },
    {
      value: '10&30',
      label: `${faitRateItem?.symbol}10M-${faitRateItem?.symbol}30M`,
    },
    {
      value: '30&50',
      label: `${faitRateItem?.symbol}30M-${faitRateItem?.symbol}50M`,
    },
    {
      value: '50&100',
      label: `${faitRateItem?.symbol}50M-${faitRateItem?.symbol}100M`,
    },
    {
      value: '100&',
      label: `>=${faitRateItem?.symbol}100M`,
    },
  ]

  return (
    <>
      <FundingFilterRoundsStyled style={{ height: 'calc(80vh - 124px)' }}>
        <FundingFilterRoundsBoxStyled style={{ marginTop: 20 }}>
          {[
            {
              value: '',
              label: t('p.all', { ns: 'fundraising' }),
            },
            ...listData,
          ]?.map(item => {
            return (
              <FundingFilterRoundsItemStyled
                data-focus={selectedValue === item?.value}
                key={item?.value}
                style={{ height: 40, padding: 0 }}
                onClick={e => {
                  stopEvent(e)
                  if (item?.value?.length === 0) {
                    handleChangeValue('')
                  } else if (selectedValue === item?.value) {
                    handleChangeValue('')
                  } else {
                    handleChangeValue(item?.value)
                  }
                  // 清除输入框的值
                  setMinValue('')
                  setMaxValue('')
                  setSelectedValue(item?.value)
                }}
              >
                {item?.label}
              </FundingFilterRoundsItemStyled>
            )
          })}
        </FundingFilterRoundsBoxStyled>

        <FundingFilterCustomFlexStyled>{t('p.custom')}</FundingFilterCustomFlexStyled>

        <Flex mt={12} align="center" gap={4}>
          <Input.Group size="md" styles={{ root: { paddingRight: 16, width: '100%' } }}>
            <Input
              size="md"
              placeholder={'Min'}
              value={minValue}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                handleInputChange(e.target.value, true)
              }}
            />
            <span className="fz-12-400 c-text-1">M</span>
          </Input.Group>

          <span>-</span>

          <Input.Group size="md" styles={{ root: { paddingRight: 16, width: '100%' } }}>
            <Input
              size="md"
              placeholder={'Max'}
              value={maxValue}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                handleInputChange(e.target.value, false)
              }}
            />
            <span className="fz-12-400 c-text-1">M</span>
          </Input.Group>
        </Flex>
      </FundingFilterRoundsStyled>
    </>
  )
}

export default observer(FFAmount)
